// rootComponent/actionTypes.js
export const TOGGLEMODALVISIBILITY = 'rootComponent/TOGGLEMODALVISIBILITY';
export const OPEN_MODAL = 'rootComponent/OPEN_MODAL';
export const CLOSE_MODAL = 'rootComponent/CLOSE_MODAL';
